import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormSelectChoice, InputSelectComponentProps, InputSelectComponent } from '@sheerid/jslib';

const SchoolTypeComponent = ({
    value,
    isErrored,
    options,
    onChange,
    onKeyDown = undefined,
    placeholder,
}: InputSelectComponentProps) => (
    <div className="sid-field sid-school-type">
        <div className="sid-l-space-top-md" />
        <label htmlFor="sid-school-type">
            <div className="sid-field__label sid-field__label--required sid-school-type__label sid-l-space-btm-sm">
                <FormattedHTMLMessage
                    id="schoolType"
                    defaultMessage="Type of School"
                />
            </div>
        </label>
        <InputSelectComponent
            fieldId="status"
            inputId="sid-school-type"
            isErrored={isErrored}
            options={options}
            onChange={(status: FormSelectChoice) => onChange(status)}
            onKeyDown={onKeyDown}
            value={value}
            placeholder={placeholder}
        />
        {
            isErrored ? (
                <div className="sid-field-error">
                    <FormattedHTMLMessage
                        id="errorId.invalidStatus"
                        defaultMessage="Invalid school type"
                    />
                </div>
            ) : null
        }
    </div>
);

export { SchoolTypeComponent };
